export default {
  // Common variables
  maxWidth: '1180px',
  minWidth: '300px',

  // Fonts
  textFont: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  headerFont: "'Montserrat Alternates', sans-serif",

  // Colors — all reference CSS custom properties so [data-theme="dark"] overrides apply automatically
  brandLighter: 'var(--color-brand-lighter)',
  brandLight: 'var(--color-brand-light)',
  brand: 'var(--color-brand)',
  brandDark: 'var(--color-brand-dark)',
  brandDarker: 'var(--color-brand-darker)',

  accentLighter: 'var(--color-accent-lighter)',
  accentLight: 'var(--color-accent-light)',
  accent: 'var(--color-accent)',
  accentDark: 'var(--color-accent-dark)',

  softAlertSuccess: 'var(--soft-alert-success)',
  softAlertInProgress: 'var(--soft-alert-in-progress)',
  softAlertError: 'var(--soft-alert-error)',
  softAlertSuccessText: 'var(--soft-alert-success-text)',
  softAlertInProgressText: 'var(--soft-alert-in-progress-text)',
  // softAlertErrorText: такой же, как brandDarker

  textLighter: 'var(--color-text-lighter)',
  textLight: 'var(--color-text-light)',
  text: 'var(--color-text)',

  backgroundWhite: 'var(--color-background-white)',
  backgroundLighter: 'var(--color-background-lighter)',
  backgroundLight: 'var(--color-background-light)',
  backgroundDark: 'var(--color-background-dark)',
  backgroundDarker: 'var(--color-background-darker)',

  shadow: 'var(--color-shadow)',
  divider: 'var(--color-divider)',

  white: 'var(--color-white)',
  backgroundIcon: 'var(--color-background-icon)',
  backgroundScroll: 'var(--color-background-scroll)',
  favUnderline: 'var(--color-fav-underline)',
  currentDesign: 'var(--color-current-design)',

  // Border
  borderRadius: 'none'
};
